// LinkedIn Insight Tag — loads ONLY on the Trigrly gifting domain, never on
// shadowlabs.ai or localhost. trigrly.com runs LinkedIn Ads; shadowlabs.ai does
// not, and the site is one shared build served on both, so we gate on hostname
// (same approach as the per-domain PostHog key in ./posthog.js). Imported for
// its side effect from App.js; self-initializes once at load.
const GIFTING_HOSTS = new Set(['trigrly.com', 'www.trigrly.com']);
const PARTNER_ID = '10579353';

if (
  typeof window !== 'undefined' &&
  GIFTING_HOSTS.has(window.location.hostname) &&
  !window._linkedin_partner_id
) {
  window._linkedin_partner_id = PARTNER_ID;
  window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
  window._linkedin_data_partner_ids.push(PARTNER_ID);

  if (!window.lintrk) {
    window.lintrk = function (a, b) {
      window.lintrk.q.push([a, b]);
    };
    window.lintrk.q = [];
  }

  const first = document.getElementsByTagName('script')[0];
  const tag = document.createElement('script');
  tag.type = 'text/javascript';
  tag.async = true;
  tag.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
  first.parentNode.insertBefore(tag, first);
}
